export default __webpack_public_path__ + "static/media/logo_tuc.0d000f13.png";